module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "chap-010"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_tit"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("UNSPIRITUAL PEOPLE"), _c('br')]), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=1%20Corinthians+3:1-4&version=RSV",
      "target": "_blank"
    }
  }, [_vm._v("1 CORINTHIANS 3:1-4")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERVIEW: ")])]), _vm._v("The Holy Spirit dwells and remains in believers who stay firm in the conviction of their new birth (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER")]), _vm._v("). Solid food is found in the teaching of the Father and the Son in the New Testament, prefigured in the manna of Moses in the Old Testament (O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN, ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AESARIUS OF ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RLES")]), _vm._v("). To be ready only for milk is to be fixated on miracles (S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVERIAN OF ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ABALA")]), _vm._v("). For these hearers the level of teaching must be downwardly adjusted (T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORET OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YR")]), _vm._v("). Recall that the Lord displayed his glory on the mountain to only three disciples, who were told to say nothing about what had happened until his resurrection (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER")]), _vm._v("). Factionalism produces jealousy, deepens carnality and takes away the freedom to hear the gospel (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM")]), _vm._v("). Paul’s emphasis on the spiritual person is not to be understood as a Manichaean rejection of the body (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE")]), _vm._v(").")]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-085"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("3:1 "), _c('i', [_vm._v("Babes in Christ")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DDRESSED AS ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARNAL ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EOPLE.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER: ")]), _vm._v("These people were carnal because they were still slaves to the desires of the present age. Although they had been baptized and had received the Holy Spirit, they were carnal because after their baptism they had returned to their old lives, which they had renounced. The Holy Spirit dwells in a person into whom he has poured himself if that person stays firm in the conviction of his new birth. Otherwise he departs, but only provisionally. If that person repents, the Spirit will return, for he is always ready for what is good, being a lover of repentance. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN171",
      "id": "ap_NFIN171-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OT A ")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANICHAEAN ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EJECTION OF THE ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ODY.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE: ")]), _vm._v("Paul was not speaking of their bodies but of their carnal spirits. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITY OF ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD 22.21.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN172",
      "id": "ap_NFIN172-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-086"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("3:2a "), _c('i', [_vm._v("Fed with Milk, Not Solid Food")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLID ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOD.")])]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN: ")]), _vm._v("In spiritual matters, “solid food” means the teaching about the Father and the Son. In the Old Testament, solid food appears under the guise of typology, as, for example, when we read about the serpent which Moses lifted up in the wilderness."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN173",
      "id": "ap_NFIN173-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" This serpent was a picture, or type, of Christ, which explains why it was that the people were saved when they looked at it. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON 1 ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 1.12.17-23.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN174",
      "id": "ap_NFIN174-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTIAN ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EACHERS, ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IKE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OWS, ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EED BY ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WO ")]), _vm._v("U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DDERS.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AESARIUS OF ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RLES: ")]), _vm._v("Not unfittingly, dearly beloved, do elders seem to bear a likeness to cows. Just as a cow has two udders to nurse her calf, so also elders ought to feed the Christian people with two udders: both the Old and the New Testaments. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERMON 4.4.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN175",
      "id": "ap_NFIN175-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NLY ")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILK. ")])]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVERIAN OF ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ABALA: ")]), _vm._v("By “milk” Paul means moral teaching and miracles. Solid food, by contrast, is the proclamation of the doctrines of God. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AULINE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY FROM THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEK ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN176",
      "id": "ap_NFIN176-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-087"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("3:2b "), _c('i', [_vm._v("Not Yet Ready")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OT ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EADY.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER: ")]), _vm._v("Although they had been born again in Christ, they were not yet fit to receive spiritual things. Although they had received the faith which is the seed of the Spirit, they had produced no fruit worthy of God, but like "), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("babies, they were eager for the sensations of imperfection. But Paul, who was a man of God and a spiritual physician, gave to each of them according to his strength, so that no one should suffer scandal where spiritual matters were concerned because of imperfection or inexperience. Paul is also arguing strongly against those who were complaining that they had not heard anything spiritual for a long time, when in fact they were not worthy to hear it. The false apostles conveyed their message indiscriminately to anyone who would listen, but it is generally agreed that our Lord and Master spoke one way in public and another way to his disciples in private, and that even among the latter a distinction was made, for he displayed his glory on the mountain to only three disciples and told them to say nothing about what had happened until he should rise again from the dead. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN177",
      "id": "ap_NFIN177-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITHOUT ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XCUSE.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("The Corinthians’ inability to receive solid food was not by nature but by choice, so they were without excuse. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES OF ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL TO THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 7.3.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN178",
      "id": "ap_NFIN178-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DJUSTING THE ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVEL OF ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EACHING.")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORET OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YR: ")]), _vm._v("Paul is saying that he adjusted the level of his teaching to their lack of understanding. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRST ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 179.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN179",
      "id": "ap_NFIN179-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-088"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("3:3 "), _c('i', [_vm._v("Jealousy and Strife")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TILL OF THE ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LESH.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("Here Paul talks about the particular problem which made the Corinthians carnal. There were other matters, like fornication and uncleanness, which he would deal with later, but first he wants to tackle something which he has clearly been trying to put right for some time. If jealousy makes people carnal, every one of us ought to be crying out because of our sin and covering ourselves in sackcloth and ashes. Who is not tainted with this? I say this of others only because I know how true it is of me. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES OF ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL TO THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 8.3.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN180",
      "id": "ap_NFIN180-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-089"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("3:4 "), _c('i', [_vm._v("Behaving as Mere Humans")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACTIONALISM.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("It was the factionalism of the Corinthians that produced jealousy, and that in turn made them carnal. Once they were carnal, they were no longer free to hear truths of a more spiritual kind. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES OF ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL TO THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 8.5.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN181",
      "id": "ap_NFIN181-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6887dfe7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap11.vue
// module id = 111
// module chunks = 0